'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'computer';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e4e5';
var svgPathData = 'M336 352L64 352c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l273.3 0c1.9-11.5 5.9-22.3 11.5-32L64 32C28.7 32 0 60.7 0 96L0 320c0 35.3 28.7 64 64 64l272 0 0-32zm1.3 96L112 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l236.8 0c-5.6-9.7-9.6-20.5-11.5-32zM432 64l96 0c8.8 0 16 7.2 16 16l0 48-128 0 0-48c0-8.8 7.2-16 16-16zm-16 96l128 0 0 64-128 0 0-64zm128 96l0 176c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-176 128 0zM384 80l0 352c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zM504 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComputer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;